<template>
  <div>
    <div
      v-if="item.show_title && item?.name"
      :class="getTextClass(web_content_type)"
    >
      {{ item.name }}
    </div>
    <div class="mt-2 flex flex-wrap justify-content-center">
      <div class="w-10">
        <div class="video-wrapper relative">
          <div class="flex justify-content-center">
            <iframe
              :title="item.name"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
              allowfullscreen
              :src="`https://www.youtube.com/embed/${item.youtube_id}`"
              class="absolute h-full sm:w-19 md:w-9 lg:w-9 border-none m-0 p-0"
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { getTextClass } from '~/composables/useUtils'
const props = defineProps({
  item: Object,
  web_content_type: Object
})
</script>
<style lang="scss" scoped>
.video-wrapper {
  padding-bottom: 45.25%;
  /* 16:9, for an aspect ratio of 1:1 change to this value to 100% */
  // padding-bottom: 75%; /* 4:3 */
  @media only screen and (max-width: 800px) {
    padding-bottom: 75% !important;
  }
}
</style>
